export default function toTitleCase(word: string): string {
	return (
		word.substring(0, 1).toUpperCase()
		+ word.substring(1).toLowerCase()
	);
}
